import { Controller } from "@hotwired/stimulus"

// Show/hide sections based on a named radio group's value. Each revealable
// section sets data-radio-reveal-when="<value>" and is shown only when the
// controller's radio group has that value checked. Scoped by the group name so
// multiple instances (e.g. the step form's email picker and its non-engagement
// choice) coexist on one form. (#218 phase 3)
//
// Wiring: data-controller="radio-reveal" data-radio-reveal-name-value="<group>"
//         radios: data-action="change->radio-reveal#update"
//         sections: data-radio-reveal-target="section" data-radio-reveal-when="<value>"
export default class extends Controller {
  static targets = ["section"]
  static values = { name: String }

  connect() {
    this.update()
  }

  update() {
    const checked = this.element.querySelector(`input[name="${this.nameValue}"]:checked`)
    const value = checked ? checked.value : null
    this.sectionTargets.forEach((section) => {
      section.hidden = section.dataset.radioRevealWhen !== value
    })
  }
}
